import { getFirstOrderConnections } from '@/components/diagrams/FlowChart/utils/nodes';

import { EntityDiagramActionFn, NodeMouseEnterAction } from '../types';

export const nodeMouseEnterAction: EntityDiagramActionFn<
  NodeMouseEnterAction
> = (state, { node }, _queueEffect) => {
  const highlightedIds = getFirstOrderConnections(
    node,
    state.nodes,
    state.edges
  );

  return { ...state, highlightedIds };
};
